import type { ReactNode } from 'react';

import { WorkspaceConcurrencyContext } from './workspaceConcurrencyLimit';

/** Provides the workspace's enforced limit to everything below a page that read it. */
export function WorkspaceConcurrencyProvider({
  limit,
  children,
}: {
  limit: number | null | undefined;
  children: ReactNode;
}) {
  return (
    <WorkspaceConcurrencyContext.Provider value={limit ?? null}>
      {children}
    </WorkspaceConcurrencyContext.Provider>
  );
}
